// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__38duI","title":"Info_title__2t0CG","selects":"Info_selects__UYpIo","requiredAsterisk":"Info_requiredAsterisk__srHHL"};